exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#audio-display-wrap[data-v-08c4f036]{position:relative}.display[data-v-08c4f036]{height:25vh}#load-overlay[data-v-08c4f036]{background-color:#000;opacity:.65;z-index:10;position:absolute;top:0;left:0}#load-spinner[data-v-08c4f036]{color:#fff;z-index:20;position:absolute;top:0;left:0}", ""]);

// exports
